import React from 'react';

interface AlertProps {
  title?: string;
  children?: React.ReactNode;
  description?: React.ReactNode;
  variant?: 'info' | 'warning' | 'danger' | 'success' | 'neutral';
  className?: string;
  icon?: string;
  action?: React.ReactNode;
}

export const Alert: React.FC<AlertProps> = ({ title, children, description, variant = 'info', className = '', icon, action }) => {
  const variants = {
    info: 'bg-blue-50 text-blue-800 border-blue-200',
    warning: 'bg-amber-50 text-amber-800 border-amber-200',
    danger: 'bg-red-50 text-red-800 border-red-200',
    success: 'bg-emerald-50 text-emerald-800 border-emerald-200',
    neutral: 'bg-slate-50 text-slate-800 border-slate-200',
  };

  const icons = {
    info: 'ri-information-line',
    warning: 'ri-alert-line',
    danger: 'ri-error-warning-line',
    success: 'ri-checkbox-circle-line',
    neutral: 'ri-information-line',
  };

  return (
    <div className={`flex gap-3 p-4 rounded-md border ${variants[variant]} ${className}`}>
      <i className={`${icon || icons[variant]} text-xl mt-0.5`} />
      <div className="flex-1">
        {title && <h4 className="sm:text-sm text-xs mb-1">{title}</h4>}
        <div className="sm:text-sm text-xs opacity-90">{children ?? description}</div>
      </div>
      {action}
    </div>
  );
};
